import React from 'react'
import '../404.css'
import { Link } from 'react-router-dom'

function NoMatchComponent() {
  return (
    <div className="wrap">
      <div className="banner"><img src="/fuel-404-logo.png" alt="" /></div>
      <span className="myBackButton">
        <Link to="/" >
          <button className="myHomeButton">Back to Home</button>
        </Link>
      </span>
    </div>
  )
}

export default NoMatchComponent